import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild } from "@angular/core";
import { PartnerNamesEnum } from "../../shared";

@Component({
    selector: 'apotheken-reservierung',
    templateUrl: "./apotheken-reservierung.component.html",
    styleUrls: ["./apotheken-reservierung.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ApothekenReservierungComponent implements OnInit {
    @Input() partnerName: string = "";

    PartnerNamesEnum = PartnerNamesEnum;

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get jsPanelContentWidth() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientWidth;
        }
        else {
            return document.body.clientWidth;
        }
    }


    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }
}
